import { render } from "./CsvViewer.vue?vue&type=template&id=7fbd8ab8&scoped=true"
import script from "./CsvViewer.vue?vue&type=script&lang=js"
export * from "./CsvViewer.vue?vue&type=script&lang=js"

import "./CsvViewer.vue?vue&type=style&index=0&id=7fbd8ab8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fbd8ab8"]])

export default __exports__